import { render } from "./VaccinationCalendarView.vue?vue&type=template&id=56da1526&scoped=true"
import script from "./VaccinationCalendarView.vue?vue&type=script&lang=js"
export * from "./VaccinationCalendarView.vue?vue&type=script&lang=js"

import "./VaccinationCalendarView.vue?vue&type=style&index=0&id=56da1526&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56da1526"]])

export default __exports__